<template>

</template>

<script>
	import wxlogin from "vue-wxlogin";
	import upload from "../../compents/upload/upload";
	export default {
		components: {
			wxlogin,
			upload
		},
		data() {
			return {

			}
		},
		mounted() {

		},
		methods: {

		},
	}
</script>

<style lang="less" scoped>

</style>